"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mappedOnly = void 0;
var mappedOnly = [
    {
        artifact_id: 11683081,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 12245844,
                    procedure_name: null,
                    procedure_code: "72148",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    }
];
exports.mappedOnly = mappedOnly;
//# sourceMappingURL=mapped-only.js.map